import { render, staticRenderFns } from "./AccreditationsPage.vue?vue&type=template&id=b21e5692&"
import script from "./AccreditationsPage.vue?vue&type=script&lang=js&"
export * from "./AccreditationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports